import React from 'react';
import { View, Svg, Defs, LinearGradient, Stop, Rect } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';
import { shade } from 'PDF/TemplateEngine/utils/mixColor';

// Fondo vectorial de la portada. Se dibuja en SVG (no es una imagen) para que
// escale sin perder nitidez y tome el color primario del tenant.
//
// El viewBox usa el lienzo del diseño original (420x594, proporción A4), así
// las medidas de las barras se trasladan literales y el SVG las escala a la
// página real.
const VIEW_W = 420;
const VIEW_H = 594;

// 'bars': portada corporativa oscura. Velo degradado del primario del tenant +
// barras blancas de alturas escalonadas y opacidades inversas (las cortas
// pisan más fuerte). Es un fondo OSCURO: el texto de la portada se invierte.
//
// [x, alturaEnPorcentaje, opacidad] — 12 barras de 26 de ancho, una cada 34.
const BARS = [
  [0, 100, 0.06],
  [34, 78, 0.1],
  [68, 52, 0.16],
  [102, 88, 0.05],
  [136, 34, 0.2],
  [170, 64, 0.09],
  [204, 44, 0.14],
  [238, 96, 0.05],
  [272, 28, 0.22],
  [306, 70, 0.08],
  [340, 46, 0.15],
  [374, 84, 0.06],
];
const BAR_WIDTH = 26;

// Cuánto se oscurece el primario para el tope del velo. El diseño original va
// de #00366B a #0056B3; 0.6 reproduce esa relación para cualquier primario.
const VEIL_TOP_SHADE = 0.6;

export const PORTRAIT_PATTERNS = ['none', 'bars'];

// Los fondos oscuros obligan a invertir el texto de la portada, o no se lee.
export const isDarkPattern = (pattern) => pattern === 'bars';

function PortraitBackground({ pattern }) {
  const { colors } = useTemplateColors();
  const primary = colors?.primary || '#0055b3';

  if (!isDarkPattern(pattern)) return null;

  return (
    // El <Svg> va DENTRO de un <View> absoluto: un Svg de alto 100% puesto
    // directamente en la Page entra al flujo de layout, no cabe, y react-pdf
    // agrega una página en blanco ("SVG can't wrap between pages"). El View
    // absoluto lo saca del flujo. Verificado renderizando el PDF real.
    <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
      <Svg viewBox={`0 0 ${VIEW_W} ${VIEW_H}`} style={{ width: '100%', height: '100%' }}>
        <Defs>
          <LinearGradient
            id="portraitVeil"
            x1="0"
            y1="0"
            x2="0"
            y2={VIEW_H}
            gradientUnits="userSpaceOnUse"
          >
            <Stop offset="0" stopColor={shade(primary, VEIL_TOP_SHADE)} />
            <Stop offset="1" stopColor={primary} />
          </LinearGradient>
        </Defs>

        <Rect x={0} y={0} width={VIEW_W} height={VIEW_H} fill="url(#portraitVeil)" />

        {BARS.map(([x, heightPct, opacity]) => (
          <Rect
            key={x}
            x={x}
            y={0}
            width={BAR_WIDTH}
            height={(VIEW_H * heightPct) / 100}
            fill="#ffffff"
            fillOpacity={opacity}
          />
        ))}
      </Svg>
    </View>
  );
}

export default PortraitBackground;
